import Project from '../project';

/**
 * Create the action
 */

const { thunk, request, success, error } = Project.destroy((id, fetch) => {
    return fetch.delete(`/projects/${id}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };